<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Customer Requests</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-btn color="accent" small to="/new-request">
            <v-icon left dark>mdi-plus</v-icon>New Request
          </v-btn>
        </v-row>

        <v-row>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-row>

        <v-row>
          <v-col cols="12" sm="12" md="12">
            <!-- start of table -->
            <v-data-table
              :headers="headers"
              :items="customerRequests"
              :search="search"
            ></v-data-table>
            <!-- end -->
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!-- snackbar -->
    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
export default {
  name: "ClientRequestsIndex",
  data: () => ({
    search: "",
    customerRequests: [],
    headers: [
      { text: "Customer", value: "Name" },
      { text: "Phone", value: "PhoneNumber" },
      { text: "Product(s)", value: "ItemName" },
      { text: "Price Offered", value: "Offer" },
    ],
    clientRequests: [],
  }),
  methods: {
    getData() {
      const self = this;
      this.$store
        .dispatch("get", `/customers-requests`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.customerRequests = res.ResponseData;
           
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getData();
  },
};
</script>